// eslint-disable-next-line no-restricted-imports
import { metrics, openTelemetryIntegration } from '@glovo/custom-metrics'
import { logger } from '../..'
import { metricsDefinitions } from '../config/index.node'
import { getConfig } from '@/tools/config'

export const initOpenTelemetryIntegration = () => {
  const { env, name, project } = getConfig()
  metrics.init({
    integrations: [openTelemetryIntegration({ metricsDefinitions, logger })],
    service: name,
    namespace: 'glovoapp',
    tags: ['platform:server', `env:${env}`, `app:${project}`],
  })
}
